import styled from "styled-components"

export const Title = styled.h5`
  margin: 2rem 0 1.5rem;
  font-weight: 600;
`
export const InputGroup = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  margin-bottom: 1.5rem;
`
export const InputPrefix = styled.div`
  min-width: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
  font-size: 14px;
  font-weight: 600;
  color: #6f7782;
  background-color: #eff6ff;
  border-radius: 10px 0px 0px 10px;
`
export const InputSuffix = styled.div`
  min-width: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.5rem;
  font-size: 14px;
  font-weight: 600;
  color: #6f7782;
  cursor: pointer;
  background-color: #fff;
  margin-left: -10px;
  border: 1px solid #e8f0fe;
  border-left: 0px;
  border-radius: 0px 10px 10px 0px;
`
export const Input = styled.input`
  border: 1px solid #eff6ff;
  font-size: 14px;
  background-color: #fff;
  height: 50px;
  margin-bottom: 0 !important;
  border-radius: 0px 10px 10px 0px;
  &:hover {
    box-shadow: none;
  }
  &:focus {
    box-shadow: none;
    background-color: #fff;
    border: 1px solid #eff6ff;
  }
`
export const Form = styled.form`
  border-radius: 5px;
  text-align: left !important;
  // box-shadow: none !important;
  // background-color: #fff;
  & .form-control,
  & .input-group-text {
    border: 0px;
    font-size: 14px;
    padding: 0.6rem 0.75rem;
  }
  & .input-group-text {
    background-color: #fff;
    color: #5e6e82;
  }
  & .form-control:focus {
    box-shadow: none;
    border-color: var(--color-primary);
  }
  & .form-control:-internal-autofill-selected {
    background-color: #fff !important;
  }
  & .btn-login-gg {
    margin-top: 0.5rem;
    color: var(--color-grey);
    font-weight: 500;
    font-size: 14px;
    padding: 0rem 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    &:focus,
    &:active {
      box-shadow: var(--box-secondary-focus);
    }
    & > span {
      font-size: 20px;
    }
  }
  & .text-link-primary {
    color: var(--color-primary);
    &:hover {
      text-decoration: underline;
    }
  }
`
export const FooterForm = styled.div`
  margin-top: 1rem;
  display: flex;
  place-content: center space-between;
  flex-flow: row wrap;
  font-size: 14px;
  & > a {
    text-decoration: none;
    cursor: pointer;
    color: var(--color-primary);
    &:hover {
      text-decoration: underline;
    }
  }
`
export const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
  @media (max-width: 576px) {
    flex-direction: column-reverse;
  }
`
export const Name = styled.h3`
  color: var(--color-primary);
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 0;
`
export const Logo = styled.img`
  max-height: 35px;
  max-width: 100%;
  object-fit: contain;
  cursor: pointer;
`

export const SubmitSpan = styled.span`
  display: inline-block;
  margin-left: 0.5rem;
  transform: translate3d(-0.2rem, 0, 0);
  transition: transform 0.3s;
  transition-timing-function: cubic-bezier(0.75, 0, 0.125, 1);
  font-size: 16px;
`
export const Submit = styled.button`
  width: fit-content;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  height: 50px;
  &:hover,
  &:focus {
    color: #fff;
    box-shadow: none;
  }
  &:hover ${SubmitSpan} {
    transform: translate3d(0.2rem, 0, 0);
  }
`
export const ErrorMessage = styled.div`
  font-size: 13px;
`
export const LoginContainer = styled.div`
  @media (max-width: 576px) {
    & .login {
      padding-left: 1rem;
      padding-right: 1rem;
      margin: 0.5rem 0 !important;
    }
  }
`
export const LoginBanner = styled.div`
  box-shadow: rgba(214, 231, 255, 1) 0px 3px 5px;
  border-radius: 0.25rem;
  overflow: hidden;
`
export const Banner = styled.div`
  max-height: 305px;
  overflow: hidden;
  display: block !important;
  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
